"use client"

import { useState } from "react";
import Sidebar from "./sidebar";  // Ensure Sidebar is default exported
import Dashboard from "./dashboard"; // Assuming Dashboard is also default exported

export default function DefaultHome() {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleMenuClick = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    return (
        <div className="flex min-h-screen">
            {/* Sidebar - hidden on mobile by default, can be toggled */}
            <div className={`${isMobileMenuOpen ? "block" : "hidden"} md:block`}>
                <Sidebar />
            </div>

            {/* Main content */}
            <Dashboard onMenuClick={handleMenuClick} />
        </div>
    );
}
